import type { GameState, Inventario, MetricasFase } from './quiz.types';

export const PROGRESSO_STORAGE_VERSION = 2 as const;

export interface SessaoPersistida {
  faseAtual: number;
  status: GameState;
  indicePerguntaAtual: number;
  checkpointAtual: number;
  vidas: number;
  comboAtual: number;
  pontuacaoFase: number;
  ajudasUsadasNestaFase: number;
  desafiosConcluidosNestaJornada: string[];
  tempoRestantePergunta: number;
  dueloAtivo: boolean;
}

export interface ProgressoPersistido {
  version: typeof PROGRESSO_STORAGE_VERSION;
  moedas: number;
  vidas: number;
  ultimaVidaPerdida: number | null;
  inventario: Inventario;
  faseAtual: number;
  fasesConcluidas: number[];
  tutorialConcluido: boolean;
  conquistasDesbloqueadas: string[];
  ultimoBonusDiario: number | null;
  historicoMetricas: Record<number, MetricasFase>;
  sessao: SessaoPersistida | null;
}

export const SESSION_PERSIST_STATUSES: GameState[] = [
  'PLAYING',
  'ERROR_PORTAL',
  'MINIGAME',
  'GAME_OVER',
];
